import { inject, injectable } from 'inversify';
import {
  AddressesServiceInterface,
  CheckStoreAvailabilityRequestParams,
  CheckStoreAvailabilityResponse,
  CreateAddressRequestParams,
  DeleteAddressRequestParams,
  DeleteAddressResponse,
  EditAddressRequestParams,
  GetAddressesResponse,
  GetAllAddressesRequestParams,
  SetMainAddressRequestParams,
} from './addressesService.types';
import HttpClient from '../../../http';
import { backendUrl } from 'src/config';
import { Address } from 'src/types/common';

@injectable()
class AddressesService implements AddressesServiceInterface {
  @inject(HttpClient) private client!: HttpClient;

  async getAll({ userId, accessToken }: GetAllAddressesRequestParams) {
    const response = await this.client
      .getClient()
      .get<GetAddressesResponse>(`/users/${userId}/addresses/`, {
        baseURL: backendUrl,
        headers: {
          Authorization: `Token ${accessToken}`,
        },
      });

    return response;
  }

  async setMain({
    userId,
    addressId,
    accessToken,
  }: SetMainAddressRequestParams) {
    const response = await this.client
      .getClient()
      .post<Address>(
        `/users/${userId}/addresses/${addressId}/set-main/`,
        undefined,
        {
          baseURL: backendUrl,
          headers: {
            Authorization: `Token ${accessToken}`,
          },
        }
      );

    return response;
  }

  async create({ userId, accessToken, address }: CreateAddressRequestParams) {
    const response = await this.client
      .getClient()
      .post<Address>(`/users/${userId}/addresses/`, address, {
        baseURL: backendUrl,
        headers: {
          Authorization: `Token ${accessToken}`,
        },
      });

    return response;
  }

  async edit({
    userId,
    accessToken,
    address,
    addressPk,
  }: EditAddressRequestParams) {
    const response = await this.client
      .getClient()
      .put<Address>(`/users/${userId}/addresses/${addressPk}/`, address, {
        baseURL: backendUrl,
        headers: {
          Authorization: `Token ${accessToken}`,
        },
      });

    return response;
  }

  async checkStoreAvailability({
    accessToken,
    storeSlugName,
  }: CheckStoreAvailabilityRequestParams) {
    const response = await this.client
      .getClient()
      .get<CheckStoreAvailabilityResponse>(
        `/stores/${storeSlugName}/check-availability/`,
        {
          baseURL: backendUrl,
          headers: {
            Authorization: `Token ${accessToken}`,
          },
        }
      );

    return response;
  }

  async delete({ addressId, userId, accessToken }: DeleteAddressRequestParams) {
    const response = await this.client
      .getClient()
      .delete<DeleteAddressResponse>(
        `/users/${userId}/addresses/${addressId}/`,
        {
          baseURL: backendUrl,
          headers: {
            Authorization: `Token ${accessToken}`,
          },
        }
      );

    return response;
  }
}

export default AddressesService;
